import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import EditPortForm from './EditPortForm';

const EditPortDialog = ({ open, onOpenChange, port, onUpdatePort }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (portData) => {
    setIsSubmitting(true);
    try {
      await onUpdatePort(portData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Edit Port</DialogTitle>
        </DialogHeader>
        <EditPortForm 
          port={port}
          onUpdatePort={handleSubmit} 
          onCancel={() => onOpenChange(false)} 
          isSubmitting={isSubmitting}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditPortDialog;